export default __webpack_public_path__ + "static/media/04.be508fa3.png";